import { Button } from '@/src/common/components/Button'
import { Dialog, TextArea, YStack } from 'tamagui'
import { useState } from 'react'
import { SurveysE2E } from '../../e2e'

export const AdditionalComments = ({
  onSubmit,
}: {
  onSubmit: (response: { additionalComments: string }) => void
}) => {
  const [additionalComments, setAdditionalComments] = useState('')

  const handleSubmit = () => {
    onSubmit({
      additionalComments,
    })
  }

  return (
    <>
      <Dialog.Title key="title" text="center" fontSize="$6" lineHeight="$10">
        Thank you for your feedback!
      </Dialog.Title>
      <Dialog.Description fontSize="$4" lineHeight="$2">
        Is there anything else you'd like to share with the Mesa team?
      </Dialog.Description>
      <YStack gap="$4" mt="$6">
        <TextArea
          value={additionalComments}
          onChangeText={setAdditionalComments}
          placeholder="Enter any additional feedback or comments..."
          returnKeyType="send"
          submitBehavior="blurAndSubmit"
          onSubmitEditing={handleSubmit}
          testID={SurveysE2E.Ids.Input.AdditionalComments}
        />
        <Button
          title="Submit"
          onPress={handleSubmit}
          mt="$2"
          testID={SurveysE2E.Ids.Press.SubmitAdditionalComments}
        />
      </YStack>
    </>
  )
}
